package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_12_06_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-12-06")
@Composable
public fun Log_2025_12_06(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Footsmeller Remains At Large!",
        ogTitle = "Footsmeller Remains At Large!",
        date = LocalDate(2_025, 12, 6),
        aiHint = "Image, title, and description reference a joke that the players think 'Footseller' sounds like 'Footsmeller'.",
        ogDescription = "The heroes have apprehended Ludwig Voss but the dreaded Matty Footseller is loose in Freeburg, likely creeping out customers getting a pedicure at a nail salon.",
        ogImage = "images/footsmellerCoatOfArms_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A vector graphic of a coat of arms featuring a face profile and a bare foot with green wavy 'smell' lines. This is a meme reference to the character Matty Footseller, who Tuesday referred to as a Footsmeller.",
    ) {
        SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
        Log_2025_12_06_Day_1()
        SessionMediaItem(
            image = "images/footsmellerCoatOfArms_plain.svg",
            linkImage = "images/footsmellerCoatOfArms_plain.svg",
            description = "A vector graphic of a coat of arms featuring a face profile and a bare foot with green wavy 'smell' lines. This is a meme reference to the character Matty Footseller, who Tuesday referred to as a Footsmeller.",
        )
    }
}
